export default {
  "and": "و",
  "Back": "للخلف",
  "Click to Expand": "انقر للتوسيع",
  "Click to Hide": "اضغط للإخفاء",
  "Click to Highlight": "اضغط للتحديد",
  "Click to Show": "انقر للعرض",
  "Click to Show All": "انقر لعرض الكل",
  "Download": "تحميل",
  "Loading Visualization": "جاري تحميل التصوير البياني",
  "No Data Available": "لا تتوفر بيانات",
  "more": "أخرى",
  "Powered by D3plus": "مدعوم بواسطة D3plus",
  "Share": "مشاركة",
  "Shift+Click to Hide": "Shift+انقر للإخفاء",
  "Shift+Click to Highlight": "Shift + للتحديد اضغط",
  "Total": "المجموع",
  "Values": "القيم"
};